import { connect } from 'react-redux';

import {
  deleteTranscriptionSegmentById,
  editTranscriptionSegmentById,
} from '../../../../ducks/asset_transcriptions/thunks';

export default connect(null, {
  editTranscriptionSegmentById,
  deleteTranscriptionSegmentById,
});
